import { Button } from "@mui/material";
import styled from "styled-components";

export const FilterButton = styled(Button)`
  && {
    padding: 8px, 14px, 8px, 14px;
    background: #fbfbfb;
    border: 1px solid #fbfbfb;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #344054;
  }
`;
